import { Tabs } from 'antd';
import './App.css';
import './shadow.css';
import TopBar from './features/topBar/TopBar';
import TabPane from 'antd/es/tabs/TabPane';
import Graphs from './features/Charts/components/Graphs';
import StatusDashboard from './features/RestrictionsSigns/components/StatusDashboard';
import Footer from './features/Footer/components/Footer';
import useObjectStatusStore from './Store/ObjectStatus';
import { LocationsEnum, ObjectStatusEnum } from './Store/ObjectStatusEnum';

function App() {

  const setLogo = useObjectStatusStore((state) => state.setLogo)
  const setLocation = useObjectStatusStore((state) => state.setLocation)
  const setStatus = useObjectStatusStore((state) => state.setStatus)
  setStatus(ObjectStatusEnum.warning)
  setLogo('kcsir_logo.jpeg')
  setLocation(LocationsEnum.KCSiR)

  const tabOnChange = (activeKey: string) => {
    switch (activeKey) {
      case 'kcsir':
        setLogo('kcsir_logo.jpeg')
        setLocation(LocationsEnum.KCSiR)
        break;
      case 'ratusz':
        setLogo('kwidzyn_urzad_logo.jpeg')
        setLocation(LocationsEnum.Ratusz)
        break;
      default:
        break;
    }
  }

  return (
    <div className="App">
      <TopBar />
      <div className="App-container">
        <Tabs
          onChange={(activeKey) => { tabOnChange(activeKey) }}
          style={{ height: '100%' }}
          type="card"
          size='large'
          defaultActiveKey="1">
          <TabPane tab="KCSiR" key="kcsir">
            <StatusDashboard />
            <Graphs />
          </TabPane>
          <TabPane tab="Ratusz" key="ratusz" >
            <StatusDashboard />
            <Graphs />
          </TabPane>
        </Tabs>
      </div>
      <Footer />
    </div >
  )
}

export default App;